module.exports = __webpack_public_path__ + "img/back button.1867b9b1.svg";